import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ContentLoaderModule } from '@ngneat/content-loader';
// import { DynamicInputModule } from 'dynamic-input-width';

import { DisposalSitesUiModule } from '@digital-platform/disposal-sites/ui';
import { GeneratorsUiModule } from '@digital-platform/generators/ui';
import { PeopleUiModule } from '@digital-platform/people/ui';
import { SharedUiModule } from '@digital-platform/shared/ui';
import { SharedUiMaterialModule } from '@digital-platform/shared/ui-material';
import { WizardNavigationComponent } from '@digital-platform/sw-wizard/ui';
import { UsersUiModule } from '@digital-platform/users/ui';
import { AdditionalSupplementsFormComponent } from './additional-supplements-form/additional-supplements-form.component';
import { ApproveFormComponent } from './approve-form/approve-form.component';
import { AuthorizationAttachmentsFormComponent } from './authorization-attachments-form/authorization-attachments-form.component';
import { CardsColumnEmptyDirective } from './cards-column/cards-column-empty.directive';
import { CardsColumnComponent } from './cards-column/cards-column.component';
import { ChatterCommentsComponent } from './chatter-comments/chatter-comments.component';
import { CheckListFormComponent } from './check-list-form/check-list-form.component';
import { ChemicalCompositionFormComponent } from './chemical-composition-form/chemical-composition-form.component';
import { ChemicalPropertiesFormComponent } from './chemical-properties-form/chemical-properties-form.component';
import { CommentsSidebarComponent } from './comments-sidebar/comments-sidebar.component';
import { DeepwellCertificationFormComponent } from './deepwell-certification-form/deepwell-certification-form.component';
import { DeepwellCharacteristicsFormComponent } from './deepwell-characteristics-form/deepwell-characteristics-form.component';
import { DeepwellDisposalDestinationComponent } from './deepwell-disposal-destination/deepwell-disposal-destination.component';
import { DeepwellWasteStreamFormComponent } from './deepwell-waste-stream-form/deepwell-waste-stream-form.component';
import { WasteStreamComponent } from './display-sections/waste-stream/waste-stream.component';
import { DisposalDestinationComponent } from './disposal-destination/disposal-destination.component';
import { ExpressOfflineCreateComponent } from './express-offline-create/express-offline-create.component';
import { ExpressOfflineQuestionsComponent } from './express-offline-questions/express-offline-questions.component';
import { ExpressQuestionsComponent } from './express-questions/express-questions.component';
import { ExpressWasteEditComponent } from './express-waste-edit/express-waste-edit.component';
import { ExpressWasteStreamFormComponent } from './express-waste-stream-form/express-waste-stream-form.component';
import { ExpressWasteViewComponent } from './express-waste-view/express-waste-view.component';
import { IncompleteFormComponent } from './incomplete-form/incomplete-form.component';
import { InternalOnlyAttachmentComponent } from './internal-only-form/internal-only-attachment-form';
import { InternalStatusHistoryTableComponent } from './internal-status-history-table/internal-status-history-table.component';
import { LabAnalyticalAttachmentFormComponent } from './lab-analytical-attachment-form/lab-analytical-attachment-form.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { PhysicalCharacteristicsComponent } from './physical-characteristics/physical-characteristics.component';
import { PreviousSubmissionDialogComponent } from './previous-submission-dialog/previous-submission-dialog.component';
import { RegulatoryFormComponent } from './regulatory-form/regulatory-form.component';
import { RegulatoryQuestionsComponent } from './regulatory-questions/regulatory-questions.component';
import { RejectFormComponent } from './reject-form/reject-form.component';
import { ReportingSearchFormComponent } from './reporting-search-form/reporting-search-form.component';
import { SafetyDataSheetFormComponent } from './safety-data-sheet-form/safety-data-sheet-form.component';
import { ShippingPackingFormComponent } from './shipping-packing-form/shipping-packing-form.component';
import { SignatureComponent } from './signature/signature.component';
import { SignedPdfAttachmentFormComponent } from './signed-pdf-attachment-form/signed-pdf-attachment-form.component';
import { SpecialWasteManualEditComponent } from './special-waste-manual-edit/special-waste-manual-edit.component';
import { SpecialWasteOfflineCreateComponent } from './special-waste-offline-create/special-waste-offline-create.component';
import { SpecialWasteViewComponent } from './special-waste-view/special-waste-view.component';
import { StateAttachmentsFormComponent } from './state-attachments-form/state-attachments-form.component';
import { StatusChipComponent } from './status-chip/status-chip.component';
import { StatusTrackerComponent } from './status-tracker/status-tracker.component';
import { TruxMaterialDescriptionComponent } from './trux-material-description/trux-material-description.component';
import { UpdateWasteProfileMetadataComponent } from './update-waste-profile-metadata/update-waste-profile-metadata.component';
import { WasteComponentRowComponent } from './waste-component-row/waste-component-row.component';
import { WasteComponentRowsComponent } from './waste-component-rows/waste-component-rows.component';
import { WasteProfileAdminCardComponent } from './waste-profile-admin-card/waste-profile-admin-card.component';
import { WasteProfileAttachmentsLogComponent } from './waste-profile-attachments-log/waste-profile-attachments-log.component';
import { WasteProfileCardComponent } from './waste-profile-card/waste-profile-card.component';
import { WasteProfileCardLoaderComponent } from './waste-profile-card-loader/waste-profile-card-loader.component';
import { WasteProfileChangeRequestFormComponent } from './waste-profile-change-request-form/waste-profile-change-request-form.component';
import { WasteProfileCommentLogComponent } from './waste-profile-comment-log/waste-profile-comment-log.component';
import { WasteProfileDisplayComponent } from './waste-profile-display/waste-profile-display.component';
import { WasteProfileInactiveSearchTableComponent } from './waste-profile-inactive-search-table/waste-profile-inactive-search-table.component';
import { WasteProfileReportingTableComponent } from './waste-profile-reporting-table/waste-profile-reporting-table.component';
import { WasteProfileSearchFormComponent } from './waste-profile-search-form/waste-profile-search-form.component';
import { WasteProfileSearchTableComponent } from './waste-profile-search-table/waste-profile-search-table.component';
import { WasteProfileSelectComponent } from './waste-profile-select/waste-profile-select.component';
import { WasteProfileTableComponent } from './waste-profile-table/waste-profile-table.component';
import { WasteProfileTableOfContentsComponent } from './waste-profile-table-of-contents/waste-profile-table-of-contents.component';
import { WasteStreamFormComponent } from './waste-stream-form/waste-stream-form.component';

@NgModule({
  imports: [
    CommonModule,
    ContentLoaderModule,
    SharedUiMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedUiModule,
    UsersUiModule,
    PeopleUiModule,
    DisposalSitesUiModule,
    // DynamicInputModule,
    GeneratorsUiModule,
    WizardNavigationComponent,
    RouterModule.forChild([]),
  ],
  exports: [
    WasteProfileCardComponent,
    WasteProfileCardLoaderComponent,
    StatusChipComponent,
    WasteProfileTableOfContentsComponent,
    WasteStreamFormComponent,
    LabAnalyticalAttachmentFormComponent,
    RegulatoryQuestionsComponent,
    DisposalDestinationComponent,
    SafetyDataSheetFormComponent,
    AdditionalSupplementsFormComponent,
    PhysicalCharacteristicsComponent,
    WasteProfileTableComponent,
    SignatureComponent,
    ApproveFormComponent,
    IncompleteFormComponent,
    RejectFormComponent,
    WasteProfileSelectComponent,
    WasteProfileDisplayComponent,
    WasteProfileSearchFormComponent,
    WasteProfileSearchTableComponent,
    WasteProfileInactiveSearchTableComponent,
    UpdateWasteProfileMetadataComponent,
    InternalStatusHistoryTableComponent,
    TruxMaterialDescriptionComponent,
    WasteProfileCommentLogComponent,
    ShippingPackingFormComponent,
    RegulatoryFormComponent,
    DeepwellWasteStreamFormComponent,
    DeepwellCharacteristicsFormComponent,
    DeepwellDisposalDestinationComponent,
    CheckListFormComponent,
    ChemicalCompositionFormComponent,
    ChemicalPropertiesFormComponent,
    DeepwellCertificationFormComponent,
    PreviousSubmissionDialogComponent,
    WasteComponentRowComponent,
    WasteComponentRowsComponent,
    WasteProfileReportingTableComponent,
    SpecialWasteViewComponent,
    SpecialWasteManualEditComponent,
    WasteProfileChangeRequestFormComponent,
    ExpressQuestionsComponent,
    WasteProfileAdminCardComponent,
    ExpressWasteStreamFormComponent,
    MultiSelectComponent,
    CommentsSidebarComponent,
    ChatterCommentsComponent,
    StatusTrackerComponent,
    ExpressWasteViewComponent,
    ExpressWasteEditComponent,
    WasteProfileAttachmentsLogComponent,
    AuthorizationAttachmentsFormComponent,
    CardsColumnComponent,
    CardsColumnEmptyDirective,
    StateAttachmentsFormComponent,
    InternalOnlyAttachmentComponent,
    ReportingSearchFormComponent,
    WasteStreamComponent,
    MatIconModule,
    SpecialWasteOfflineCreateComponent,
    SignedPdfAttachmentFormComponent,
    ExpressOfflineCreateComponent,
    ExpressOfflineQuestionsComponent,
  ],
  declarations: [
    WasteProfileCardComponent,
    WasteProfileCardLoaderComponent,
    StatusChipComponent,
    WasteProfileTableOfContentsComponent,
    WasteStreamFormComponent,
    LabAnalyticalAttachmentFormComponent,
    RegulatoryQuestionsComponent,
    DisposalDestinationComponent,
    SafetyDataSheetFormComponent,
    AdditionalSupplementsFormComponent,
    PhysicalCharacteristicsComponent,
    WasteProfileTableComponent,
    SignatureComponent,
    ApproveFormComponent,
    IncompleteFormComponent,
    RejectFormComponent,
    WasteProfileSelectComponent,
    WasteProfileDisplayComponent,
    WasteProfileSearchFormComponent,
    WasteProfileSearchTableComponent,
    WasteProfileInactiveSearchTableComponent,
    UpdateWasteProfileMetadataComponent,
    InternalStatusHistoryTableComponent,
    TruxMaterialDescriptionComponent,
    WasteProfileCommentLogComponent,
    ShippingPackingFormComponent,
    RegulatoryFormComponent,
    DeepwellWasteStreamFormComponent,
    DeepwellCharacteristicsFormComponent,
    DeepwellDisposalDestinationComponent,
    CheckListFormComponent,
    ChemicalCompositionFormComponent,
    ChemicalPropertiesFormComponent,
    DeepwellCertificationFormComponent,
    PreviousSubmissionDialogComponent,
    WasteComponentRowComponent,
    WasteComponentRowsComponent,
    WasteProfileReportingTableComponent,
    SpecialWasteViewComponent,
    SpecialWasteManualEditComponent,
    WasteProfileChangeRequestFormComponent,
    ExpressQuestionsComponent,
    WasteProfileAdminCardComponent,
    ExpressWasteStreamFormComponent,
    MultiSelectComponent,
    CommentsSidebarComponent,
    ChatterCommentsComponent,
    StatusTrackerComponent,
    ExpressWasteViewComponent,
    ExpressWasteEditComponent,
    WasteProfileAttachmentsLogComponent,
    AuthorizationAttachmentsFormComponent,
    CardsColumnComponent,
    CardsColumnEmptyDirective,
    StateAttachmentsFormComponent,
    InternalOnlyAttachmentComponent,
    ReportingSearchFormComponent,
    WasteStreamComponent,
    SpecialWasteOfflineCreateComponent,
    SignedPdfAttachmentFormComponent,
    ExpressOfflineCreateComponent,
    ExpressOfflineQuestionsComponent,
  ],
})
export class WasteProfilesUiModule {}
